declare const THREE: any;

export class Edge extends (THREE.Mesh as { new(geometry, material): any; }) {

  private static transformation = new THREE.Matrix4()
    .makeRotationX(THREE.Math.degToRad(-90))
    .multiply(new THREE.Matrix4().makeTranslation(-0.5, 0, 0));

  constructor(firstpoint, secondPoint) {
    const geometry = new THREE.PlaneBufferGeometry(1, 3).applyMatrix(Edge.transformation);
    const material = new THREE.MeshBasicMaterial({
      color: 0x0000ff,
      side: THREE.DoubleSide,
      depthWrite: false,
      depthTest: false,
    });
    super(geometry, material);
    this.update(firstpoint, secondPoint);
    this.position.copy(firstpoint);
    this.renderOrder = 2;
  }

  update(firstPoint, secondPoint) {
    this.scale.x = firstPoint.distanceTo(secondPoint);
    this.rotation.y = -Math.atan2(secondPoint.z - firstPoint.z, secondPoint.x - firstPoint.x) + THREE.Math.degToRad(-180);
  }

  center() {
    return this.localToWorld(new THREE.Vector3(-0.5, 0, 0));
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/FloorHull/Edge.ts